import Vue from "vue";
import { colors } from "quasar";

const state = {
  attempts: 0,
  clients: [],
  languages: [],
  layout: [],
  login: [],
  register: [],
  user_profile: [],
};

const actions = {
  SET_PARAMS(
    context,
    [login, clients, register, user_profile, languages, attempts, layout]
  ) {
    if (!context.rootGetters["common/id_user_client_selected"]) {
      //   Set client colors
      colors.setBrand("primary", login.colors.primary);
      colors.setBrand("secondary", login.colors.secondary);
      colors.setBrand("accent", login.colors.tertiary);
    }

    context.commit("SAVE_PARAMS", [
      login,
      clients,
      register,
      user_profile,
      languages,
      attempts,
      layout,
    ]);
  },

  SET_ATTEMPTS(context, [attempts]) {
    context.commit("SAVE_ATTEMPTS", [attempts]);
  },
};

const mutations = {
  SAVE_PARAMS: (
    state,
    [login, clients, register, user_profile, languages, attempts, layout]
  ) => {
    Vue.set(state, "login", login);
    Vue.set(state, "clients", clients);
    Vue.set(state, "register", register);
    Vue.set(state, "user_profile", user_profile);
    Vue.set(state, "languages", languages);
    Vue.set(state, "attempts", attempts);
    Vue.set(state, "layout", layout);
  },

  SAVE_ATTEMPTS: (state, [attempts]) => {
    Vue.set(state, "attempts", attempts);
  },
};

const getters = {
  app_version: (state) => {
    return state.login.app_version;
  },

  attempts: (state) => {
    return state.attempts;
  },

  background: (state) => {
    return state.login.background;
  },

  clients: (state) => {
    return state.clients;
  },

  colors: (state) => {
    return state.login.colors;
  },

  default_language_id: (state) => {
    return state.login.default_language_id;
  },

  full_background: (state) => {
    return state.login.full_background;
  },

  languages: (state) => {
    return state.languages;
  },

  layout: (state) => {
    return state.layout;
  },

  login_accept_document: (state) => {
    return state.login.accept_document;
  },

  login_user_pre_register: (state) => {
    return state.login.user_pre_register;
  },

  login_user_register: (state) => {
    return state.login.user_register;
  },

  login_default_language_id: (state) => {
    return state.login.default_language_id;
  },

  login_oauth2: (state) => {
    return state.login.oauth2;
  },

  login_dark_text: (state) => {
    return state.login.login_dark_text;
  },

  logo: (state) => {
    return state.login.logo;
  },

  logo_pt: (state) => {
    return state.login.logo_pt;
  },

  logo_en: (state) => {
    return state.login.logo_en;
  },

  logo_es: (state) => {
    return state.login.logo_es;
  },

  logo_fr: (state) => {
    return state.login.logo_fr;
  },

  logo_mobile: (state) => {
    return state.login.logo_mobile;
  },

  logo_mobile_pt: (state) => {
    return state.login.logo_mobile_pt;
  },

  logo_mobile_en: (state) => {
    return state.login.logo_mobile_en;
  },

  logo_mobile_es: (state) => {
    return state.login.logo_mobile_es;
  },

  logo_mobile_fr: (state) => {
    return state.login.logo_mobile_fr;
  },

  oauth2: (state) => {
    return state.login.oauth2;
  },

  password_strong_level: (state) => {
    return state.register.password_strong_level;
  },

  recaptcha: (state) => {
    return state.login.use_recaptcha;
  },

  register: (state) => {
    return state.register;
  },

  register_fields: (state) => {
    return state.register.fields ? state.register.fields : [];
  },

  text: (state) => {
    return state.login.text;
  },

  text_header: (state) => {
    return state.login.text_header;
  },

  user_profile: (state) => {
    return state.user_profile;
  },

  under_maintenance: (state) => {
    return state.login.under_maintenance;
  },

  use_background: (state) => {
    return state.login.use_background;
  },

  user_pre_register: (state) => {
    return state.login.user_pre_register;
  },

  user_register: (state) => {
    return state.login.user_register;
  },

  use_portfolio_page: (state) => {
    return state.login.use_portfolio_page;
  },

  zendesk_help: (state) => {
    return state.login.use_zendesk_help;
  },

  login_colors: (state) => {
    return state.login.colors;
  },

  cookies_type: (state) => {
    return state.login.cookies_type;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
